import { gql } from '@/__generated__';

export const deleteRefundDocument = gql(/* GraphQL */ `
  mutation DeleteRefund($where: RefundWhereUniqueInput!) {
    deleteRefund(where: $where) {
      id
    }
  }
`);
